import React, { useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import _ from "lodash";
import PropTypes from 'prop-types';

/* istanbul ignore next */
const RentConfigurationDetail = (props) => {
    const location = useLocation();
    const { isEditable = false } = props;
    const { id } = useParams();
    const navigate = useNavigate();
    const rentDetails = location?.state?.rentDetails;
    const isViewMode = location?.state?.isViewMode;

    const [error, setErrors] = useState({
        warehouse: "",
        company: "",
        seller: "",
        monthlyRatePerCFT: "",
        rentFrequency: "",
        baselineRate: "",
        rateBySize: []
    });

    const [formData, setFormData] = useState({
        id: 0,
        warehouse: "",
        company: "",
        seller: "",
        monthlyRatePerCFT: "",
        rentFrequency: "Monthly",
        baselineRate: "",
        rateBySize: [
            {
                size: "Small",
                sizeCFT: "0.1 – 0.5 CFT",
                ratePerDay: "3.00"
            },
            {
                size: "Medium",
                sizeCFT: "0.6 – 1.5 CFT",
                ratePerDay: "5.50"
            },
            {
                size: "Large",
                sizeCFT: "1.6 – 3.0 CFT",
                ratePerDay: "8.00"
            },
            {
                size: "Extra Large",
                sizeCFT: "3.1 – 6.0 CFT",
                ratePerDay: "12.00"
            },
            {
                size: "Oversized",
                sizeCFT: "6.1 – 100 CFT",
                ratePerDay: "18.00"
            }
        ]
    });

    const handleBack = () => {
        navigate('/rent-configuration');
    };

    useEffect(() => {
        if (id && rentDetails) {
            setFormData({
                id: rentDetails.id,
                warehouse: rentDetails.warehouse,
                company: rentDetails.companySeller?.split(' / ')[0] || "",
                seller: rentDetails.companySeller?.split(' / ')[1] || "",
                monthlyRatePerCFT: "5",
                rentFrequency: rentDetails.rentFrequency,
                baselineRate: rentDetails.baselineRate.toString(),
                rateBySize: formData.rateBySize
            });
        }
    }, [id, rentDetails]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...error, [name]: '' });
    };

    const handleRateBySizeChange = (index, field, value) => {
        let data = _.cloneDeep(formData);
        data.rateBySize[index][field] = value;
        setFormData(data);
    };

    const handleSave = async () => {
        // Validate required fields
        let hasError = false;
        let newErrors = { ...error };

        if (!formData.warehouse) {
            newErrors.warehouse = "Warehouse is required";
            hasError = true;
        }
        if (!formData.company) {
            newErrors.company = "Company is required";
            hasError = true;
        }
        if (!formData.seller) {
            newErrors.seller = "Seller is required";
            hasError = true;
        }
        if (!formData.baselineRate) {
            newErrors.baselineRate = "Baseline Rate is required";
            hasError = true;
        }

        if (hasError) {
            setErrors(newErrors);
            return;
        }

        // TODO: Add API call to save data
        toast.success("Rent configuration saved successfully");
        navigate('/rent-configuration');
    };

    const getPageTitle = () => {
        if (isViewMode) return "View";
        if (id) return "Edit";
        return "Create";
    };

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec">
                    <span>
                        {getPageTitle()} Rent Configuration
                    </span>
                    <div className="top_right_button_container">
                        {!isViewMode && (
                            <button
                                className="btn cus-seconday-bg-btn mr-2"
                                onClick={handleSave}
                            >
                                Save
                            </button>
                        )}
                        <button
                            className="btn cus-primary-transparent-btn"
                            onClick={handleBack}
                        >
                            Back
                        </button>
                    </div>
                </div>

                <div className="cus-page-content-sec">
                <div className="incomingAccordion accordion">
                    <div className="row fontFix">
                        <div className="col-lg-12">
                            <Accordion
                                defaultActiveKey={["0", "1", "2"]}
                                alwaysOpen={true}
                            >
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        General{" "}
                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className="row addressForm">
                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                <label htmlFor="warehouse">Warehouse</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="warehouse"
                                                    name="warehouse"
                                                    value={formData.warehouse}
                                                    onChange={handleInputChange}
                                                    disabled
                                                />
                                                <div className='require-field'>{error.warehouse}</div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                <label htmlFor="company">Company</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="company"
                                                    name="company"
                                                    value={formData.company}
                                                    onChange={handleInputChange}
                                                    disabled
                                                />
                                                <div className='require-field'>{error.company}</div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                <label htmlFor="seller">Seller</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="seller"
                                                    name="seller"
                                                    value={formData.seller}
                                                    onChange={handleInputChange}
                                                    disabled
                                                />
                                                <div className='require-field'>{error.seller}</div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        Rate Card{" "}
                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className="row addressForm">
                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                <label htmlFor="monthlyRatePerCFT">Monthly Rate per CFT (USD)</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="monthlyRatePerCFT"
                                                    name="monthlyRatePerCFT"
                                                    value={formData.monthlyRatePerCFT}
                                                    onChange={handleInputChange}
                                                    disabled={isViewMode}
                                                    placeholder="5"
                                                />
                                                <div className='require-field'>{error.monthlyRatePerCFT}</div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                <label htmlFor="rentFrequency">Rent Frequency</label>
                                                <select
                                                    className="form-control"
                                                    id="rentFrequency"
                                                    name="rentFrequency"
                                                    value={formData.rentFrequency}
                                                    onChange={handleInputChange}
                                                    disabled={isViewMode}
                                                >
                                                    <option value="Daily">Daily</option>
                                                    <option value="Weekly">Weekly</option>
                                                    <option value="Monthly">Monthly</option>
                                                    <option value="Quarterly">Quarterly</option>
                                                    <option value="Yearly">Yearly</option>
                                                </select>
                                                <div className='require-field'>{error.rentFrequency}</div>
                                            </div>
                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                <label htmlFor="baselineRate">Set Monthly Baseline (Fixed) Rate</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="baselineRate"
                                                    name="baselineRate"
                                                    value={formData.baselineRate}
                                                    onChange={handleInputChange}
                                                    disabled={isViewMode}
                                                    placeholder="5000.00"
                                                />
                                                <div className='require-field'>{error.baselineRate}</div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        Rate by Size - Returns{" "}
                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className="table-responsive">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Size</th>
                                                        <th>Size Range From (CFT)</th>
                                                        <th>Size Range To (CFT)</th>
                                                        <th>Rate per Day</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {formData.rateBySize.map((item, index) => (
                                                        <tr key={item.size}>
                                                            <td>{item.size}</td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={item.sizeFrom || item.sizeCFT.split('–')[0].trim()}
                                                                    onChange={(e) => handleRateBySizeChange(index, 'sizeFrom', e.target.value)}
                                                                    disabled={isViewMode}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={item.sizeTo || item.sizeCFT.split('–')[1]?.trim().replace(' CFT', '')}
                                                                    onChange={(e) => handleRateBySizeChange(index, 'sizeTo', e.target.value)}
                                                                    disabled={isViewMode}
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={item.ratePerDay}
                                                                    onChange={(e) => handleRateBySizeChange(index, 'ratePerDay', e.target.value)}
                                                                    disabled={isViewMode}
                                                                    placeholder="3.00"
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </main>
    );
}

RentConfigurationDetail.propTypes = {
    isEditable: PropTypes.bool,
};

export default RentConfigurationDetail;
